export default __webpack_public_path__ + "media/images/logo-symbol-icon-56b4ca574a292e6687f39c3b38ba0e00.svg";